import {
	fetchMasterBootstrap,
	selectSession,
	setGuestVerificationLazyLoad,
} from '../redux/slices/sessionSlice';
import {
	fetchSingleProfile,
	getVicasQueueStatusCall,
	selectProfile,
	updateSingleProfile,
} from '../redux/slices/profileSlice';
import React, {
	forwardRef,
	useEffect,
	useImperativeHandle,
	useRef,
} from 'react';
import Select, { StylesConfig } from 'react-select';
import { selectStage, skipStage } from '../redux/slices/stageSlice';
import { useAppDispatch, useAppSelector } from '../redux/hook';

import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getCapitalCase } from '../utils';
import { Modal } from 'react-bootstrap';
import { onboardingState } from '../redux/slices/detSlice';
import styles from '../styles/datefieldformat.module.css';
import Swal from 'sweetalert2';
import useState from 'react-usestateref';
import { useTranslation } from 'react-i18next';
import validateByType from './validateByType';

// const { settings } = useAppSelector(selectSession);
// interface CountrySelect { // Was being used for nationality.
// 	value: number;
// 	label: string;
// }

const customStyles: StylesConfig = {
	control: (provided, state) =>
		({
			...provided,
			borderColor: 'var(--bs-input-border-color)',
			boxShadow: state.isFocused
				? `0 0 0 1px var(--bs-input-border-color)`
				: 'none',
			fontSize: '0.8em',
			minHeight: '38px', // adjust height
		} as any),
	valueContainer: (provided) =>
		({
			...provided,
			padding: '0.375rem 0.75rem', // âœ… this actually affects input padding
		} as any),
	input: (provided) =>
		({
			...provided,
			margin: '0', // optional, remove extra spacing inside input
			padding: '0', // optional
		} as any),
};

const searchableSelectStyles: StylesConfig = {
	...customStyles,
	valueContainer: (provided) =>
		({
			...provided,
			padding: '0 0.75rem',
			overflow: 'visible',
		} as any),
	input: (provided) =>
		({
			...provided,
			margin: '0',
			padding: '0',
		} as any),
	placeholder: (provided) =>
		({
			...provided,
			margin: '0',
		} as any),
	singleValue: (provided) =>
		({
			...provided,
			margin: '0',
		} as any),
};
interface setUDFFieldSelect {
	value: string;
}

interface PhoneCodeSelect {
	value: string;
	label: string;
}

interface ResidenceCountrySelect {
	value: number | null;
	label: string;
}

interface NationalityCountrySelect {
	value: number | null;
	label: string;
}

interface IssueCountrySelect {
	value: number | null;
	label: string;
}

type CountryItem = {
	countryID: number;
	countryCode?: string;
	countryName?: string;
	phoneCode?: string;
	phoneNumberMinLength?: number | string;
	phoneNumberMaxLength?: number | string;
	isGccCountry?: boolean;
};

const CaretDownIcon = () => {
	return <FontAwesomeIcon icon="caret-down" />;
};

const arrivalTimeOptions = Array.from({ length: 48 }, (_, i) => {
	const hour = Math.floor(i / 2)
		.toString()
		.padStart(2, '0');
	const minute = i % 2 === 0 ? '00' : '30';
	const time = `${hour}:${minute}`;
	return { value: time, label: time };
});

const genderOptions = [
	{ value: 'Male', label: 'Male' },
	{ value: 'Female', label: 'Female' }, // { value: 'Prefer not to say', label: 'Prefer not to say' },
];

const placeOfIssueOptions = [
	{ value: 'DXB', label: 'Dubai' },
	{ value: 'AUH', label: 'Abu Dhabi' },
	{ value: 'SHJ', label: 'Sharjah' },
	{ value: 'FUJ', label: 'Fujairah' },
	{ value: 'RAK', label: 'Ras Al Khaimah' },
	{ value: 'AJM', label: 'Ajman' },
	{ value: 'AAN', label: 'Al Ain' },
	{ value: 'UAQ', label: 'Umm Al Quwain' },
	{ value: 'WEA', label: 'Western Areas' },
];

type Props = {
	profile: any;
	countries: any;
	fields: any;
	onSubmitSuccess: any;
	onSubmitError: any;
	docuSubmissionSkipped: any;
	originalGuestProfile: any;
	documentsSubmitted: any;
	currentProfileIndex: any;
	profileDtl: any;
	submitBehavior?: 'internal' | 'external';
	disableUserFields?: boolean;
};

const GuestProfileFormContent = forwardRef<any, Props>(
	(
		{
			profile,
			countries,
			fields,
			onSubmitSuccess,
			onSubmitError,
			docuSubmissionSkipped,
			originalGuestProfile,
			documentsSubmitted,
			currentProfileIndex,
			profileDtl,
			submitBehavior = 'internal',
			disableUserFields = false,
		},
		ref
	) => {
		const { t } = useTranslation();
		const dispatch = useAppDispatch();
		const { onboardingToken } = useAppSelector(onboardingState);
		const { stages, stage } = useAppSelector(selectStage);
		const {
			token,
			reservation,
			settings,
			emailPrimary,
			phonePrimary,
			propertyInfo,
			visitPurposes,
			accessibilityPreferences,
			supportDocs,
		} = useAppSelector(selectSession);

		const [selectedDate, setSelectedDate] = useState<Date | null>(null);
		// const [isHideLoader, setHideLoader] = useState(false);
		const [isRefreshLoader, setRefreshLoader] = useState(false);
		const isSubmitLockedRef = useRef(false);
		const countryOptionsSignatureRef = useRef('');
		let invalidInputs = false as boolean;
		const { currentProfile } = useAppSelector(selectProfile);
		// const disabledFields =
		// 	currentProfileIndex === 0 ? ['firstName', 'lastName', 'fullName'] : [];
		const disabledFields = [''];
		const [lazyLoad, setLazyLoad, lazyLoadRef] = useState(true);
		const fieldsToHandle: string[] = fields.map(
			(x: { fieldCode: any }) => x.fieldCode
		);
		const { isPostComplete: isProfilePostComplete } =
			useAppSelector(selectProfile);
		const skipAccompanyDocument =
			settings?.find(
				(setting: any) =>
					setting.parameterName === 'SkipAccompanyDetails' &&
					setting.parameterValue === 'true'
			) ?? false;
		const skipChildDocument =
			settings?.find(
				(setting: any) =>
					setting.parameterName === 'SkipChildDetails' &&
					setting.parameterValue === 'true'
			) ?? false;
		const adultMinAgeLimit = (() => {
			const ageSetting = settings?.find(
				(setting: any) => setting.parameterName === 'AdultMinAgeLimit'
			);
			const parsed = Number(ageSetting?.parameterValue);
			return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
		})();
		const childMinAgeLimit = (() => {
			const ageSetting = settings?.find(
				(setting: any) => setting.parameterName === 'ChildMinAgeLimit'
			);
			const parsed = Number(ageSetting?.parameterValue);
			return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
		})();
		const getDateYearsAgo = (years: number) => {
			const result = new Date();
			result.setHours(0, 0, 0, 0);
			result.setFullYear(result.getFullYear() - years);
			return result;
		};
		const adultMinAgeDate =
			adultMinAgeLimit !== undefined
				? getDateYearsAgo(adultMinAgeLimit)
				: undefined;
		const childMinAgeDate =
			childMinAgeLimit !== undefined
				? getDateYearsAgo(childMinAgeLimit)
				: undefined;

		const fieldAlias = {
			title: 'nameTitle',
			firstName: docuSubmissionSkipped ? 'firstName' : 'givenName',
			lastName: docuSubmissionSkipped ? 'lastName' : 'surname',
			arabicName: 'arabicName',
			arabicLastName: 'arabicLastName',
			arabicFullName: 'arabicFullName',
			documentNumber: 'documentNumber',
			documentType: 'documentClassCode',
			nationality: 'nationalityCode',
			nationalityCountry: 'nationality',
			issueCountry: 'issueCountry',
			issueDate: 'issueDate',
			expiryDate: 'expiryDate',
			countryOfResidence: 'countryOfResidence',
			email: 'email',
			phoneNo_Res: 'phoneNo_Res',
			phoneNo_UAE: 'phoneNo_UAE',
			carPlateNumber: 'carPlateNumber',
			address: 'address',
			city: 'city',
			postalCode: 'postalCode',
			phone: 'postalCode1',
			visaOrResidencePermitNo: 'visaOrResidencePermitNo',
			PlaceofEntry: 'placeofEntry',
			DateofEntry: 'dateofEntry',
			mothersName: 'mothersName',
			// dateOfBirth: 'dateOfBirth',
			dateofBirthDT: 'dateofBirthDT',
			birthPlace: 'birthPlace',
			placeOfIssue: 'issuePlace',
			placeOfBirth: 'placeOfBirth',
			accessibilityTypeDescr: 'accessibilityPreference',
			purposeOfVisitDescr: 'purposeOfVisit',
			arrivalTime: 'arrivalTime',
			gender: 'gender',
		} as any;

		const placeholderMap = {
			firstName: '',
			lastName: '',
			email: '',
			phoneNo_Res: '',
		} as any;

		const vars = {} as any;
		const setters = {} as any;
		const refs = {} as any;
		const handlers = {} as any;
		const errorfields = [] as any;
		const invalidListfields = [] as any;

		// const [vars, setVars] = useState({});
		// const [setters, setSetters] = useState();
		// const [refs, setRefs] = useState('');
		// const [handlers, setHandlers] = useState();

		const getInitialState = (
			element: any,
			profile: any,
			profileDtl: any,
			fieldAlias: any
		) => {
			console.log('calling getInitialState');
			if (profile !== null && profile !== undefined) {
				const value = (
					profileDtl !== null && profileDtl != undefined
						? (profile[fieldAlias[element]] === null ||
						  profile[fieldAlias[element]] === undefined
								? profileDtl[element] === null ||
								  profileDtl[element] === undefined
									? ''
									: profileDtl[element]
								: profile[fieldAlias[element]] === null ||
								  profile[fieldAlias[element]] === undefined
								? ''
								: profile[fieldAlias[element]]) ?? ''
						: profile[fieldAlias[element]] ?? ''
				)?.replace(/\+/g, '');

				if (
					element !== 'email' &&
					element !== 'carPlateNumber' &&
					element !== 'documentNumber'
				) {
					return getCapitalCase(value);
				}

				return value;
			} else {
				return '';
			}
		};

		fieldsToHandle.map((element) => {
			[vars[element], setters[element], refs[element]] = useState(
				getInitialState(element, profile, profileDtl, fieldAlias)
			);

			handlers[element] = (val: any) => {
				setters[element](val === null || val === undefined ? '' : val);
			};
		});

		useEffect(() => {
			if (visitPurposes) {
				const newOptions = visitPurposes.map((visit: any) => ({
					value: visit.visitPurpose,
					label: `${visit.visitPurpose}`,
				}));
				setPurposeOfVisitSelect(newOptions);
			}
		}, [visitPurposes]);

		useEffect(() => {
			if (accessibilityPreferences) {
				const newOptions = accessibilityPreferences.map((pref: any) => ({
					value: pref.preferenceName,
					label: `${pref.preferenceName}`,
				}));
				setAccessibilityPrefsSelect(newOptions);
				accessibilityPrefsRef.current = newOptions;
			}
		}, [accessibilityPreferences]);

		useEffect(() => {
			fieldsToHandle.map((element) => {
				if (profile !== null && profile !== undefined) {
					handlers[element] = (val: any) => {
						setters[element](val === null || val === undefined ? '' : val);
					};
					const newVal = getInitialState(
						element,
						profile,
						profileDtl,
						fieldAlias
					);
					if (
						element === 'email' &&
						(newVal === null || newVal === undefined || newVal === '')
					) {
						// Don't set refs[element].current
					} else if (
						element === 'phoneNo_Res' &&
						(newVal === null || newVal === undefined || newVal === '')
					) {
						// Don't set refs[element].current
					} else if (
						element === 'countryOfResidence' &&
						(newVal === null || newVal === undefined || newVal === '')
					) {
						refs[element].current = '';
						vars[element] = '';
					} else {
						refs[element].current = newVal;
						vars[element] = newVal;
					}
				} else {
					handlers[element] = (val: any) => {
						setters[element](val === null || val === undefined ? '' : val);
					};
					if (element !== 'email' && element !== 'phoneNo_Res') {
						refs[element].current = '';
						vars[element] = '';
					}
					if (element === 'countryOfResidence') {
						refs[element].current = '';
						vars[element] = '';
					}
				}
			});
		}, [profile?.profileID, profileDtl?.profileID]);

		// useEffect(() => {
		// 	const loadUdf = async () => {
		// 		if (!profile?.profileId) return;

		// 		dispatch(fetchProfileUDF({ profileID: profile.profileId }))
		// 			.unwrap()
		// 			.then((data) => {
		// 				if (data?.length) {
		// 					data.forEach((udf: any) => {
		// 						const fieldName = udf.fieldName;
		// 						const fieldValue = udf.fieldValue ?? '';
		// 						// Update ref if it exists
		// 						if (refs[fieldName]?.current !== undefined) {
		// 							refs[fieldName].current = fieldValue;
		// 						}

		// 						// Update vars if it exists
		// 						if (vars[fieldName] !== undefined) {
		// 							vars[fieldName] = fieldValue;
		// 						}
		// 					});
		// 				}
		// 			});
		// 	};

		// 	loadUdf();
		// }, [profile?.profileId]);

		useEffect(() => {
			if (isProfilePostComplete === true) {
				setRefreshLoader(false);
			}
		}, [isProfilePostComplete]);

		const [UDFFieldList, setUDFFieldSelect, UDFFieldListRef] = useState<
			setUDFFieldSelect[]
		>([]);

		// const [phoneCodeLabel, setPhoneCodeLabel, phoneCodeLabelRef] =
		// 	useState<any>(null);

		// const [phoneCodeSelect, setPhoneCodeSelect, phoneCodeRef] = useState<
		// 	PhoneCodeSelect[]
		// >([]);

		const [
			residenceCountryLabel,
			setResidenceCountryLabel,
			residenceCountryLabelRef,
		] = useState<any>(null);

		const [
			nationalityCountryLabel,
			setNationalityCountryLabel,
			nationalityCountryLabelRef,
		] = useState<any>(null);

		const [issueCountryLabel, setIssueCountryLabel, issueCountryLabelRef] =
			useState<any>(null);

		const [
			residenceCountrySelect,
			setResidenceCountrySelect,
			residenceCountryRef,
		] = useState<ResidenceCountrySelect[]>([]);

		const [
			nationalityCountrySelect,
			setNationalityCountrySelect,
			nationalityCountryRef,
		] = useState<NationalityCountrySelect[]>([]);

		const [issueCountrySelect, setIssueCountrySelect, issueCountryRef] =
			useState<IssueCountrySelect[]>([]);

		const [purposeOfVisitSelect, setPurposeOfVisitSelect, purposeOfVisitRef] =
			useState<any[]>([]);

		const [accessibilityPrefsSelect, setAccessibilityPrefsSelect] = useState<
			any[]
		>([]);
		const accessibilityPrefsRef = useRef<any[]>([]);

		const [
			purposeOfVisitLabel,
			setPurposeOfVisitLabel,
			purposeOfVisitLabelRef,
		] = useState<any>(null);

		const [
			accessibilityPreferenceLabel,
			setAccessibilityPreferenceLabel,
			accessibilityPreferenceLabelRef,
		] = useState<any>(null);

		const [genderLabel, setGenderLabel, genderLabelRef] = useState<any>(null);
		const [documentTypeLabel, setDocumentTypeLabel, documentTypeLabelRef] =
			useState<any>(null);

		const [
			purposeOfVisitOtherText,
			setPurposeOfVisitOtherText,
			purposeOfVisitOtherTextRef,
		] = useState<string>('');
		const [
			accessibilityPreferenceOtherText,
			setAccessibilityPreferenceOtherText,
			accessibilityPreferenceOtherTextRef,
		] = useState<string>('');

		const normalizeOtherText = (text: any) => (text ?? '').toString().trim();

		const isOtherOption = (option: any) => {
			const label = normalizeOtherText(option?.label).toLowerCase();
			const value = normalizeOtherText(option?.value).toLowerCase();
			return label === 'other' || value === 'other';
		};

		const isOtherLabel = (labelValue: any) =>
			normalizeOtherText(labelValue).toLowerCase() === 'other';

		const [phoneCodeSelect, setPhoneCodeSelect, phoneCodeRef] = useState<
			PhoneCodeSelect[]
		>([]);
		const [
			selectedPhoneCodeByField,
			setSelectedPhoneCodeByField,
			selectedPhoneCodeByFieldRef,
		] = useState<Record<string, string>>({});

		const handleSkip = () => {
			dispatch(
				skipStage({
					token: token,
					stageID: stage?.stepID,
					ReservationID: reservation?.ReservationID,
					type: 'checkin',
					confirmationNo: reservation?.PmsConfirmationNo,
					stages: stages,
				})
			);
		};
		const getDateFormatted = (date: any) => {
			if (date !== null && date !== undefined && date !== '') {
				// console.log('date===>>>' + date);
				// const ddt = new Date(Date.parse(date));
				// //handlers['dateOfBirth'](date);
				// // console.log('dateOfBirth ===>>>>>' + handlers['dateOfBirth'](date));
				// return ddt;
				const d = new Date(date);
				return d; // âœ… "1998-10-24"
			} else {
				return null;
			}
		};

		const getTimeFormatted = (value: any) => {
			if (value === null || value === undefined || value === '') return null;
			if (value instanceof Date) return value;
			if (typeof value === 'string') {
				const trimmed = value.trim();
				const timeMatch = trimmed.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
				if (timeMatch) {
					const hours = Number(timeMatch[1]);
					const minutes = Number(timeMatch[2]);
					if (!Number.isNaN(hours) && !Number.isNaN(minutes)) {
						const d = new Date();
						d.setHours(hours, minutes, 0, 0);
						return d;
					}
				}
			}
			const parsed = new Date(value);
			return Number.isNaN(parsed.getTime()) ? null : parsed;
		};

		const formatDateToISO = (value: any) => {
			if (!value) return value;
			if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
				return value;
			}
			const parsed = value instanceof Date ? value : new Date(value);
			if (Number.isNaN(parsed.getTime())) return value;
			const year = parsed.getFullYear();
			const month = String(parsed.getMonth() + 1).padStart(2, '0');
			const day = String(parsed.getDate()).padStart(2, '0');
			return `${year}-${month}-${day}`;
		};

		const formatTimeToHHmm = (value: any) => {
			if (!value) return value;
			if (typeof value === 'string') {
				const trimmed = value.trim();
				if (/^\d{2}:\d{2}$/.test(trimmed)) return trimmed;
				if (/^\d{2}:\d{2}:\d{2}$/.test(trimmed)) return trimmed.slice(0, 5);
			}
			const parsed = value instanceof Date ? value : new Date(value);
			if (Number.isNaN(parsed.getTime())) return value;
			const hours = String(parsed.getHours()).padStart(2, '0');
			const minutes = String(parsed.getMinutes()).padStart(2, '0');
			return `${hours}:${minutes}`;
		};

		const getAgeFromDate = (date: Date) => {
			const today = new Date();
			let age = today.getFullYear() - date.getFullYear();
			const monthDiff = today.getMonth() - date.getMonth();
			if (
				monthDiff < 0 ||
				(monthDiff === 0 && today.getDate() < date.getDate())
			) {
				age -= 1;
			}
			return age;
		};

		// useEffect(() => {
		// 	dispatch(setGuestVerificationLazyLoad(lazyLoad));
		// 	return () => {
		// 		dispatch(setGuestVerificationLazyLoad(false));
		// 	};
		// }, [lazyLoad]);

		useEffect(() => {
			const countryOfResidence = countries.find(
				(country: any) =>
					country.countryCode === profile?.countryOfResidenceCode ||
					country.countryCode === profile?.countryOfResidence
			);

			if (countryOfResidence) {
				if (
					handlers['countryOfResidence'] !== null &&
					handlers['countryOfResidence'] !== undefined
				) {
					handlers['countryOfResidence'](countryOfResidence?.countryCode);
					setResidenceCountryLabel(`${countryOfResidence?.countryName}`);
					applyResidencePhoneCodeToPhoneFields(countryOfResidence?.countryCode);
				}
			}
		}, [countries, fields, profile?.countryOfResidence]);

		useEffect(() => {
			const udfOptions = fields
				.filter((field: any) => field.isUDF)
				.map((field: any) => ({
					value: field.fieldCode,
				}));
			setUDFFieldSelect(udfOptions);
		}, [fields]);

		useEffect(() => {
			const nextSignature = (countries ?? [])
				.map(
					(country: CountryItem) =>
						`${country?.countryCode ?? ''}|${country?.countryName ?? ''}|${
							country?.phoneCode ?? ''
						}`
				)
				.join('~');
			if (countryOptionsSignatureRef.current === nextSignature) {
				return;
			}
			countryOptionsSignatureRef.current = nextSignature;

			const countryOptions = countries.map((country: CountryItem) => ({
				value: country.countryCode,
				label: `${country.countryName}`,
			}));
			setResidenceCountrySelect(countryOptions);
			setNationalityCountrySelect(
				countryOptions.map((option: ResidenceCountrySelect) => ({ ...option }))
			);
			setIssueCountrySelect(
				countryOptions.map((option: ResidenceCountrySelect) => ({ ...option }))
			);

			const phoneCodeValues: string[] = countries.reduce(
				(codes: string[], country: CountryItem) => {
					const formattedCode = formatPhoneCode(country.phoneCode ?? '');
					if (formattedCode) {
						codes.push(formattedCode);
					}
					return codes;
				},
				[]
			);
			const uniquePhoneCodes: PhoneCodeSelect[] = Array.from(
				new Set<string>(phoneCodeValues)
			).map((code: string) => ({
				value: code,
				label: `${code}`,
			}));
			setPhoneCodeSelect(uniquePhoneCodes);
		}, [countries]);

		useEffect(() => {
			if (!handlers['phoneNo_UAE']) return;

			const uaeField = fields.find((f: any) =>
				isUAEPhoneField(f.fieldCode ?? '', f.fieldName ?? '')
			);
			if (!uaeField) return;

			const currentValue = refs['phoneNo_UAE']?.current ?? '';
			const propertyMobile = (propertyInfo?.mobile ?? '').toString().trim();

			if (!currentValue && propertyMobile) {
				handlers['phoneNo_UAE']?.(propertyMobile);
				refs['phoneNo_UAE'].current = propertyMobile;
			}
		}, [fields, propertyInfo?.mobile, profile]);

		useEffect(() => {
			if (!accessibilityPrefsRef.current.length) return;
			const nationality = countries.find(
				(country: any) =>
					country.countryCode === profile?.nationality ||
					country.countryCode === profile?.nationalityCode
			);

			if (nationality) {
				if (
					handlers['nationality'] !== null &&
					handlers['nationality'] !== undefined
				) {
					handlers['nationality'](nationality?.countryCode);
					setNationalityCountryLabel(`${nationality?.countryName}`);
				}
			}
			const issueCountry = countries.find(
				(country: any) =>
					country.countryCode === profile?.issueCountry ||
					country.countryCode === profile?.issueCountryCode
			);

			if (issueCountry) {
				if (
					handlers['issueCountry'] !== null &&
					handlers['issueCountry'] !== undefined
				) {
					handlers['issueCountry'](issueCountry?.countryCode);
					setIssueCountryLabel(`${issueCountry?.countryName}`);
				}
			}

			const accessibility = accessibilityPrefsSelect.find(
				(access: any) => access.value === profile?.accessibilityTypeDescr
			);

			if (accessibility) {
				if (
					handlers['accessibilityPreference'] !== null &&
					handlers['accessibilityPreference'] !== undefined
				) {
					handlers['accessibilityPreference'](accessibility?.value);
					setAccessibilityPreferenceLabel(`${accessibility?.label}`);
					if (!isOtherOption(accessibility)) {
						setAccessibilityPreferenceOtherText('');
					}
				}
			} else {
				const existingValue = normalizeOtherText(
					profile?.accessibilityTypeDescr
				);
				const otherOption = accessibilityPrefsSelect.find((opt: any) =>
					isOtherOption(opt)
				);
				if (existingValue && otherOption) {
					handlers['accessibilityPreference']?.(otherOption.value);
					setAccessibilityPreferenceLabel(`${otherOption.label}`);
					setAccessibilityPreferenceOtherText(existingValue);
				}
			}

			const purpose = purposeOfVisitSelect.find(
				(visit: any) => visit.value === profile?.purposeOfVisitDescr
			);

			if (purpose) {
				handlers['purposeOfVisit']?.(purpose?.value);
				setPurposeOfVisitLabel(`${purpose?.label}`);
				if (!isOtherOption(purpose)) {
					setPurposeOfVisitOtherText('');
				}
			} else {
				const existingValue = normalizeOtherText(profile?.purposeOfVisitDescr);
				const otherOption = purposeOfVisitSelect.find((opt: any) =>
					isOtherOption(opt)
				);
				if (existingValue && otherOption) {
					handlers['purposeOfVisit']?.(otherOption.value);
					setPurposeOfVisitLabel(`${otherOption.label}`);
					setPurposeOfVisitOtherText(existingValue);
				}
			}

			const genderValue = profile?.gender;
			if (genderValue) {
				const genderOpt = genderOptions.find(
					(opt) => opt.value.toLowerCase() === genderValue.toLowerCase()
				);
				if (genderOpt) {
					handlers['gender']?.(genderOpt.value);
					setGenderLabel(genderOpt.label);
				}
			}

			const profileDocumentValue =
				profile?.documentClassCode ?? profile?.documentType;
			if (profileDocumentValue && Array.isArray(supportDocs)) {
				const documentTypeOption = supportDocs.find((doc: any) => {
					const boDocumentTypes = (doc?.boDocumentType ?? '')
						.toString()
						.split(',')
						.map((value: string) => value.trim())
						.filter(Boolean);

					return (
						doc?.operaDocumentCode === profileDocumentValue ||
						boDocumentTypes.includes(profileDocumentValue) ||
						doc?.documentName === profile?.documentType
					);
				});

				handlers['documentType']?.(profileDocumentValue);
				setDocumentTypeLabel(documentTypeOption?.documentName);
			}

			// Check if documentType is invalid on load
			if (
				!profileDocumentValue ||
				profileDocumentValue.toString().trim() === ''
			) {
				// onSubmitError({ message: 'Invalid document. Please rescan.' });
				console.log(
					'Invalid document. Please rescan.' + JSON.stringify(profile)
				);
			}

			// if (currentProfileIndex === 0) {
			// 	dispatch(setEmail(''));
			// 	dispatch(setPhone(''));
			// }

			let field = fields.find((f: any) => f.code === 'email');

			if (
				(field === null || field === '' || field === undefined) &&
				emailPrimary != null &&
				emailPrimary !== undefined &&
				emailPrimary !== ''
			) {
				//handlers['email'](localStorage.getItem('email_primary'));
				handlers['email'](emailPrimary);
			}

			field = fields.find((f: any) => f.code === 'phoneNo_Res');

			if (
				(field !== null || field === '' || field === undefined) &&
				phonePrimary != null &&
				phonePrimary !== undefined &&
				phonePrimary !== ''
			) {
				//handlers['phoneNo_Res'](localStorage.getItem('phone_primary'));
				handlers['phoneNo_Res'](phonePrimary);
			}
			setLazyLoad(false);
			// setHideLoader(false);
		}, [
			accessibilityPrefsSelect,
			purposeOfVisitSelect,
			profile?.profileID,
			profileDtl?.profileID,
			supportDocs,
		]);

		const getResidenceCountryCode = () => {
			const value =
				refs['countryOfResidence']?.current ?? vars['countryOfResidence'];
			return typeof value === 'string' ? value.trim() : '';
		};

		const checkMandatory = async () => {
			const DEFAULT_MANDATORY_MESSAGE = 'Field cannot be empty';
			const getMandatoryMessage = () => DEFAULT_MANDATORY_MESSAGE;

			const getCurrentDocumentType = () =>
				(
					refs['documentType']?.current ??
					vars['documentType'] ??
					profile?.documentClassCode ??
					profile?.documentType ??
					null
				)
					?.toString()
					.trim();

			const isFieldVisibleForSelectedDocumentType = (field: any) => {
				const boDocumentType = field?.boDocumentType;
				if (!boDocumentType) return true;

				const currentDocType = getCurrentDocumentType();
				if (!currentDocType) return false;

				const fieldDocTypes = boDocumentType
					.toString()
					.split(',')
					.map((s: string) => s.trim().toLowerCase())
					.filter(Boolean);
				const selectedDocTypes = currentDocType
					.split(',')
					.map((s: string) => s.trim().toLowerCase())
					.filter(Boolean);

				return fieldDocTypes.some((type: string) =>
					selectedDocTypes.includes(type)
				);
			};

			let hasInvalidInputs = false;
			let firstInvalidFieldCode = '';
			let firstInvalidMessage = '';
			const nextFieldErrors: Record<string, string> = {};

			const registerInvalidField = (
				fieldCode: string,
				fieldName: string,
				validationMessage: string
			) => {
				invalidListfields.push(fieldName);
				errorfields.push(fieldName);
				hasInvalidInputs = true;
				nextFieldErrors[fieldCode] = validationMessage;
				if (!firstInvalidFieldCode) {
					firstInvalidFieldCode = fieldCode;
					firstInvalidMessage = validationMessage;
				}
			};

			// for (const field of fields) {
			// 	const { fieldName, fieldCode } = field;
			// 	const element = field.fieldCode;
			// 	if (element !== undefined && element !== null) {
			// 		const fieldElement = document.getElementById(
			// 			element.toString()
			// 		) as HTMLInputElement;
			// 		if (!fieldElement) {
			// 			continue;
			// 		}

			// 		if (fieldElement && field.fieldType === 'Input') {
			// 			const inputError = validateFieldValue(fieldElement.value, field);
			// 			if (inputError) {
			// 				registerInvalidField(element, fieldName, inputError);
			// 			}
			// 			// Additional operations with the fieldElement if needed
			// 		} else if (fieldElement && field.fieldType.toLowerCase() === 'date') {
			// 			const dateError = validateFieldValue(vars[element], field);
			// 			if (dateError) {
			// 				registerInvalidField(element, fieldName, dateError);
			// 			}
			// 		} else if (fieldElement && field.fieldType.toLowerCase() === 'time') {
			// 			const timeError = validateFieldValue(vars[element], field);
			// 			if (timeError) {
			// 				registerInvalidField(element, fieldName, timeError);
			// 			}
			// 		} else if (field.fieldType.toLowerCase() === 'dropdown') {
			// 			const dropdownValue = refs[element]?.current ?? vars[element];
			// 			const dropdownError = validateFieldValue(dropdownValue, field);
			// 			if (dropdownError) {
			// 				registerInvalidField(element, fieldName, dropdownError);
			// 			}
			// 			// if (
			// 			// 	nationalityCountryLabel &&
			// 			// 	fieldCode === 'nationality' &&
			// 			// 	nationalityCountryLabel.trim().includes('United Kingdom')
			// 			// ) {
			// 			// 	const _placeofEntry = document.getElementById(
			// 			// 		'placeofEntry'
			// 			// 	) as HTMLInputElement;
			// 			// 	const _dateofEntry = document.getElementById(
			// 			// 		'dateofEntry'
			// 			// 	) as HTMLInputElement;
			// 			// 	if (
			// 			// 		_placeofEntry?.value === '' ||
			// 			// 		_placeofEntry?.value === null ||
			// 			// 		_placeofEntry?.value === undefined
			// 			// 	) {
			// 			// 		registerInvalidField('placeofEntry', 'Place of Entry');
			// 			// 	}
			// 			// 	if (
			// 			// 		_dateofEntry?.value === '' ||
			// 			// 		_dateofEntry?.value === null ||
			// 			// 		_dateofEntry?.value === undefined
			// 			// 	) {
			// 			// 		registerInvalidField('dateofEntry', 'Date of Entry');
			// 			// 	}
			// 			// }
			// 		}
			// 	}
			// }
			for (const field of fields) {
				const { fieldName, fieldCode, fieldType } = field;
				const element = field.fieldCode;

				if (element == null) continue;
				if (!isFieldVisibleForSelectedDocumentType(field)) continue;

				const fieldElement = document.getElementById(
					element.toString()
				) as HTMLInputElement | null;

				let value: any;

				switch (fieldType.toLowerCase()) {
					case 'input':
						if (!fieldElement) continue;
						value = fieldElement.value;
						break;

					case 'date':
					case 'time':
						if (!fieldElement) continue;
						value = vars[element];
						break;

					case 'dropdown':
						value = refs[element]?.current ?? vars[element];
						break;

					default:
						continue;
				}

				const error = validateFieldValue(value, field);

				if (error) {
					registerInvalidField(element, fieldName, error);
				}
			}
			if (
				fieldsToHandle.includes('countryOfResidence') &&
				!getResidenceCountryCode() &&
				!nextFieldErrors['countryOfResidence']
			) {
				const residenceField = fields.find(
					(field: any) => field.fieldCode === 'countryOfResidence'
				);
				registerInvalidField(
					'countryOfResidence',
					residenceField?.fieldName ?? 'Country of Residence',
					getMandatoryMessage()
				);
			}
			if (
				isOtherLabel(purposeOfVisitLabelRef?.current) &&
				!normalizeOtherText(purposeOfVisitOtherTextRef?.current)
			) {
				hasInvalidInputs = true;
				nextFieldErrors['purposeOfVisitOther'] = getMandatoryMessage();
				const purposeField = fields.find(
					(f: any) => f.fieldCode === 'purposeOfVisit'
				);
				errorfields.push(purposeField?.fieldName ?? 'Purpose of Visit');
				if (!firstInvalidFieldCode) {
					firstInvalidFieldCode = 'purposeOfVisitOther';
					firstInvalidMessage = getMandatoryMessage();
				}
			}

			if (
				isOtherLabel(accessibilityPreferenceLabelRef?.current) &&
				!normalizeOtherText(accessibilityPreferenceOtherTextRef?.current)
			) {
				hasInvalidInputs = true;
				nextFieldErrors['accessibilityPreferenceOther'] = getMandatoryMessage();
				const accessibilityField = fields.find(
					(f: any) => f.fieldCode === 'accessibilityPreference'
				);
				errorfields.push(
					accessibilityField?.fieldName ?? 'Accessibility Preference'
				);
				if (!firstInvalidFieldCode) {
					firstInvalidFieldCode = 'accessibilityPreferenceOther';
					firstInvalidMessage = getMandatoryMessage();
				}
			}

			setFieldErrors(nextFieldErrors);
			if (firstInvalidFieldCode) {
				setErrorField(firstInvalidFieldCode);
				setValidationError(firstInvalidMessage);
			} else {
				setErrorField('');
				setValidationError(undefined);
			}

			invalidInputs = hasInvalidInputs;
		};

		// useEffect(() => {
		// 	console.log('handleSubmit--');
		// 	const profileData = {
		// 		vars,
		// 		profileDocuments: [],
		// 	};

		// 	if (!invalidInputs && isSubmitData) {
		// 		submit(profileData);
		// 	}
		// }, [invalidInputs, isSubmitData]);
		// Expose only submit via ref
		useImperativeHandle(ref, () => ({
			handleSubmit,
		}));
		const handleSubmit = async (event: any) => {
			if (isSubmitLockedRef.current) {
				return;
			}

			isSubmitLockedRef.current = true;
			await checkMandatory();
			// setHideLoader(false);
			console.log('inside handleSubmit' + invalidInputs);

			//invalidInputs = true;
			//console.log(UDFFieldListRef?.current);
			const varsToSubmit = { ...vars };
			if (fieldsToHandle.includes('countryOfResidence')) {
				const selectedResidenceCountry =
					refs['countryOfResidence']?.current ?? vars['countryOfResidence'];
				varsToSubmit['countryOfResidence'] =
					typeof selectedResidenceCountry === 'string'
						? selectedResidenceCountry.trim()
						: '';
			}
			if (isOtherLabel(purposeOfVisitLabelRef?.current)) {
				varsToSubmit['purposeOfVisit'] = normalizeOtherText(
					purposeOfVisitOtherTextRef?.current
				);
			}
			if (isOtherLabel(accessibilityPreferenceLabelRef?.current)) {
				varsToSubmit['accessibilityPreference'] = normalizeOtherText(
					accessibilityPreferenceOtherTextRef?.current
				);
			}
			const profileData = {
				vars: varsToSubmit,
				UDFFieldList,
				profileDocuments: [],
			};
			if (!invalidInputs) {
				// Show confirmation popup
				Swal.fire({
					title: 'Confirm Update',
					text: 'Do you want to update your profile?',
					icon: 'question',
					showCancelButton: true,
					confirmButtonText: 'Yes, update',
					cancelButtonText: 'Cancel',
				}).then((result) => {
					if (result.isConfirmed) {
						// if (currentProfileIndex === 0) {
						// 	// localStorage.setItem('email_primary', vars['email']);
						// 	// localStorage.setItem('phone_primary', vars['phoneNo_Res']);
						// 	dispatch(setEmail(vars['email']));
						// 	dispatch(
						// 		setPhone(
						// 			getPhoneValueWithSelectedCode(
						// 				vars['phoneNo_Res'],
						// 				'phoneNo_Res'
						// 			)
						// 		)
						// 	);
						// }
						setRefreshLoader(true);
						//dispatch(updateProfile({ dto: profileData }));
						//submit(profileData);
						if (submitBehavior === 'external') {
							onSubmitSuccess(profileData);
						} else {
							updateGuestProfile(profileData);
						}
						// setHideLoader(true);
					} else {
						isSubmitLockedRef.current = false;
					}
				});
			} else {
				const errorMessage =
					errorfields && errorfields.length > 1
						? errorfields === 'Mobile Number'
							? `Please provide valid ${errorField} without special characters.`
							: `Please ensure ${errorfields.join(',')}  are valid.`
						: errorfields.length == 1
						? `Please ensure ${errorfields.join(',')}  is valid.`
						: null;

				Swal.fire({
					title: errorMessage ? '' : 'Invalid details',
					text: errorMessage ?? '',
					icon: 'error',
				}).then(function () {
					console.log('invalid inputs');
					// setHideLoader(true);
					isSubmitLockedRef.current = false;
					//setButtonLoading(false);
				});
			}
		};

		const pollVicasQueueStatus = async (profileId: number) => {
			const interval = 3000; // 3 seconds
			const maxAttempts = 24; // 4 minutes

			let attempts = 0;

			const poll = async () => {
				attempts++;

				try {
					const response = await dispatch(
						getVicasQueueStatusCall({
							token,
							sessionToken: onboardingToken,
							profileID: profileId,
						})
					).unwrap();

					console.log('VICAS Status:', response);
					const status = response?.status?.toString().trim().toLowerCase();
					const isPending = status === 'pending';

					// Success
					if (response?.result === true) {
						console.log('VICAS Processed');

						setRefreshLoader(false);
						onSubmitSuccess(response);
						return;
					}

					// Failed cases
					if (status === 'reject' || status === 'failed') {
						console.log(response.message || 'Failed to process document');

						setRefreshLoader(false);
						onSubmitError(response);
						isSubmitLockedRef.current = false;
						return;
					}

					if (
						!isPending &&
						response?.result === false &&
						response?.message !== null &&
						response?.message !== undefined
					) {
						console.log(response.message || 'Failed to process document');

						setRefreshLoader(false);
						onSubmitError(response);
						isSubmitLockedRef.current = false;
						return;
					}
					// Timeout
					if (attempts >= maxAttempts) {
						console.log('VICAS Polling timeout');

						setRefreshLoader(false);
						isSubmitLockedRef.current = false;
						response.message =
							'Processing is taking longer than expected. Please check later.';
						onSubmitError(response);
						// Optional: show processing message
						// showToast("Still processing. Please check later.");
						return;
					}

					// Continue polling
					setTimeout(poll, interval);
				} catch (err) {
					console.error('VICAS polling error:', err);

					setRefreshLoader(false);
					isSubmitLockedRef.current = false;
				}
			};

			// Start polling
			poll();
		};
		const updateGuestProfile = (data: any) => {
			try {
				const residenceCountryValue = data?.vars?.countryOfResidence;
				const residenceCountryCode =
					typeof residenceCountryValue === 'string'
						? residenceCountryValue.trim()
						: '';
				if (
					fieldsToHandle.includes('countryOfResidence') &&
					!residenceCountryCode
				) {
					setRefreshLoader(false);
					isSubmitLockedRef.current = false;
					Swal.fire({
						title: 'Invalid details',
						text: 'Field cannot be empty',
						icon: 'error',
					});
					return false;
				}

				const profile = currentProfile;
				const mappedData = {
					fieldCode: '',
					fieldValue: null as string | null,
				};

				const requestData: { fieldCode: string; fieldValue: any }[] = [];

				Object.entries(data.vars).forEach(([key, value]: [string, any]) => {
					// Specify the type of value as any
					const newData = { ...mappedData };
					const fieldMeta = fields.find((f: any) => f.fieldCode === key);
					const isPhoneField = isPhoneOrMobileField(
						key,
						fieldMeta?.fieldName ?? ''
					);

					newData.fieldCode = key;
					if (isPhoneField) {
						newData.fieldValue = getPhoneValueWithSelectedCode(value, key);
					} else if (key === 'placeOfIssue') {
						newData.fieldValue = getPlaceOfIssueOption(value)?.label ?? value;
					} else if (key === 'countryOfResidence') {
						newData.fieldValue = residenceCountryCode;
					} else if (
						fieldMeta?.fieldType &&
						fieldMeta.fieldType.toLowerCase() === 'date'
					) {
						newData.fieldValue = formatDateToISO(value);
					} else if (
						fieldMeta?.fieldType &&
						fieldMeta.fieldType.toLowerCase() === 'time'
					) {
						newData.fieldValue = formatTimeToHHmm(value);
					} else {
						newData.fieldValue = value;
					}
					requestData.push(newData);
				});

				const UDFFields: [string, any][] = [];
				console.log('udfFields--' + JSON.stringify(profile?.profileID));

				const dto = {
					// token: token,
					fields: requestData,
					transactionGUID: profile?.profileID,
					profileID: profile?.profileID ?? 0,
					pmsProfileID: profile?.pmsProfileID ?? '',
					pmsConfirmationNo: reservation?.PmsConfirmationNo,
					// udfFields: udfFields,
				};
				// console.log('Pro##' + JSON.stringify(dto));
				dispatch(
					updateSingleProfile({
						token: token,
						sessionToken: onboardingToken,
						dto: dto,
					})
				)
					.unwrap()
					.then((resp: any) => {
						/* eslint-disable no-debugger */
						//debugger;
						console.log('profile?.profileID--' + profile?.profileID);
						/* eslint-enable no-debugger */
						//console.log('updateSingleProfile =' + JSON.stringify(resp));

						if (resp?.result === true) {
							pollVicasQueueStatus(profile?.profileID ?? 0);
						} else {
							setRefreshLoader(false);
							isSubmitLockedRef.current = false;
							console.log('updateSingleProfile failed', resp);
							onSubmitError(resp);
						}
					})
					.catch((error: any) => {
						setRefreshLoader(false);
						console.log(JSON.stringify(error));
						isSubmitLockedRef.current = false;
						if (onSubmitError) {
							onSubmitError(error);
						} else {
							Swal.fire({
								title: 'Update error',
								text:
									error?.message || 'An error occurred while updating profile',
								icon: 'error',
							});
						}
					});
				// const result = await dispatch(updateProfile({ dto: dto })).unwrap();
				// return Boolean(result);
				return true;
			} catch (error) {
				console.log(JSON.stringify(error));
				isSubmitLockedRef.current = false;
			}
		};

		const alphanumeric = (_string: any, allowSpaces = true) => {
			const pattern = allowSpaces ? /^[ A-Za-z0-9]*$/ : /^[A-Za-z0-9]*$/;
			const isValid = pattern.test(_string);
			return isValid;
		};

		const [validationError, setValidationError] = useState<string | undefined>(
			undefined
		);
		const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});

		const [validationErrorEU, setValidationErrorEU] = useState<boolean>(false);

		const [errorField, setErrorField] = useState('');
		const isGccCountrySelected = (selectedCountryCode: any) => {
			/* eslint-disable no-debugger */
			debugger;
			const data = getCountryData();
			const country = data.find(
				(c: CountryItem) =>
					c.countryCode?.toLowerCase() === selectedCountryCode?.toLowerCase()
			);

			return country?.IsGccCountry === true;
		};
		const validateFieldValue = (value: any, field: any) => {
			const DEFAULT_MANDATORY_MESSAGE = 'Field cannot be empty';
			const getCurrentDocumentType = () =>
				(
					refs['documentType']?.current ??
					vars['documentType'] ??
					profile?.documentClassCode ??
					profile?.documentType ??
					null
				)
					?.toString()
					.trim();

			const isFieldVisibleForSelectedDocumentType = (f: any) => {
				if (!f.boDocumentType) return true;
				const currentDocType = getCurrentDocumentType();
				if (!currentDocType) return false;

				const fieldDocTypes = f.boDocumentType
					.toString()
					.split(',')
					.map((s: string) => s.trim().toLowerCase())
					.filter(Boolean);
				const selectedDocTypes = currentDocType
					.split(',')
					.map((s: string) => s.trim().toLowerCase())
					.filter(Boolean);

				return fieldDocTypes.some((type: string) =>
					selectedDocTypes.includes(type)
				);
			};
			const isDateValue = value instanceof Date;
			// const isEmptyValue =
			// 	value === null ||
			// 	value === undefined ||
			// 	(typeof value === 'string' && value.trim() === '');
			const isEmptyValue =
				value === null ||
				value === undefined ||
				(typeof value === 'string' && value.trim() === '') ||
				(isDateValue && Number.isNaN(value.getTime())) ||
				(typeof value === 'object' &&
					!isDateValue &&
					value !== null &&
					('value' in value ? !value.value : Object.keys(value).length === 0));

			if (field?.isMandatory && isEmptyValue) {
				return DEFAULT_MANDATORY_MESSAGE;
			}

			let error = validateByType(value, field);

			if (
				!error &&
				field.fieldCode === 'documentNumber' &&
				value &&
				!alphanumeric(value, false)
			) {
				error = field.validationMessage || 'Invalid Document Number';
			}

			if (!error && field.fieldCode === 'email' && value) {
				error = validateByType(value, {
					...field,
					validationType: 'email',
					validationMessage: field.validationMessage || 'Invalid Email ID',
				});
			}

			if (
				!error &&
				isPhoneOrMobileField(field.fieldCode ?? '', field.fieldName ?? '') &&
				value
			) {
				error = validateByType(value, {
					...field,
					validationType: 'phone',
					validationMessage: field.validationMessage || 'Invalid phone number',
				});

				if (!error) {
					error = getPhoneLengthError(field.fieldCode ?? '', value);
				}
			}

			const fieldCodeLower = (field.fieldCode ?? '').toString().toLowerCase();
			if (
				!error &&
				adultMinAgeLimit !== undefined &&
				fieldCodeLower.includes('dateofbirth') &&
				value &&
				!profile?.isChild
			) {
				const parsed = new Date(value);
				if (Number.isFinite(parsed.getTime())) {
					const age = getAgeFromDate(parsed);
					if (age < adultMinAgeLimit) {
						error =
							field.validationMessage ||
							`Guest must be at least ${adultMinAgeLimit} years old`;
					}
				}
			}

			if (
				!error &&
				adultMinAgeLimit !== undefined &&
				fieldCodeLower.includes('dateofbirth') &&
				value &&
				profile?.isChild
			) {
				const parsed = new Date(value);
				if (Number.isFinite(parsed.getTime())) {
					const age = getAgeFromDate(parsed);
					if (age >= adultMinAgeLimit) {
						error =
							field.validationMessage ||
							`Child must be younger than ${adultMinAgeLimit} years old`;
					}
				}
			}
			/* eslint-disable no-debugger */
			debugger;
			const selectedNationalityCountryCode =
				refs['nationality']?.current ??
				vars['nationality'] ??
				profile?.nationality;

			const isArabicField =
				field.fieldCode === 'arabicName' ||
				field.fieldCode === 'arabicLastName' ||
				field.fieldCode === 'arabicFullName';

			if (
				isArabicField &&
				isFieldVisibleForSelectedDocumentType(field) &&
				isGccCountrySelected(selectedNationalityCountryCode) &&
				(!value || value.trim() === '')
			) {
				error = `${field.fieldName} is required for arab nationality`;
			}
			if (!error && isArabicField && value && !isArabicOnlyText(value.trim())) {
				error = `${field.fieldName} should contain Arabic characters only`;
			}
			return error;
		};

		const validateInput = (
			value: string,
			field: string,
			fieldName: string,
			IsMandatory: boolean,
			validationType: string,
			validationMessage: string,
			fieldType: string,
			isUDFField: boolean,
			boDocumentType?: string
		) => {
			const inputElement = document.getElementById(field);
			inputElement?.classList.remove('is-invalid');

			const error = validateFieldValue(value, {
				fieldCode: field,
				fieldName,
				isMandatory: IsMandatory,
				validationType,
				validationMessage,
				fieldType,
				isUDF: isUDFField,
				boDocumentType,
			});

			if (error) {
				setErrorField(field);
				inputElement?.classList.add('is-invalid');
				setFieldErrors((prev) => ({ ...prev, [field]: error }));
			} else {
				setFieldErrors((prev) => {
					const next = { ...prev };
					delete next[field];
					return next;
				});
			}

			return error;
		};

		const validateDate = (
			value: any,
			field: string,
			fieldName: string,
			isMandatory: boolean,
			validationType: string,
			validationMessage: string,
			fieldType: string,
			boDocumentType?: string
		) => {
			const error = validateFieldValue(value, {
				fieldCode: field,
				fieldName,
				isMandatory,
				validationType,
				validationMessage,
				fieldType,
				boDocumentType,
			});

			if (error) {
				setErrorField(field);
				if (fieldType.toLowerCase() === 'date') {
					setSelectedDate(null);
				}
				setFieldErrors((prev) => ({ ...prev, [field]: error }));
			} else {
				setFieldErrors((prev) => {
					const next = { ...prev };
					delete next[field];
					return next;
				});
			}

			return error;
		};

		const handleDatePickerChange = (
			date: Date | null,
			elementName: string,
			fieldName: string,
			isFieldMandatory: boolean,
			validationType: string,
			Message: string,
			fieldType: string,
			boDocumentType?: string
		) => {
			setSelectedDate(date);
			handlers[elementName](date);
			const value = date;
			const error = validateDate(
				value,
				elementName,
				fieldName,
				isFieldMandatory,
				validationType,
				Message,
				fieldType,
				boDocumentType
			);
			setValidationError(error);
			setErrorField(error ? elementName : '');
		};

		const isEmiratesIdDocumentType = (
			documentTypeValue?: string | null,
			documentTypeLabel?: string | null
		) => {
			const normalizedText = [documentTypeValue, documentTypeLabel]
				.filter(Boolean)
				.join(' ')
				.toLowerCase();

			return (
				normalizedText.includes('emirates') ||
				normalizedText.includes('residence') ||
				normalizedText.includes('eid')
			);
		};

		const getUaeCountry = () =>
			countries.find(
				(c: any) =>
					c.CountryCode === 'ARE' ||
					c.CountryCode === 'UAE' ||
					c.CountryName?.toUpperCase().includes('UNITED ARAB EMIRATES')
			);

		useEffect(() => {
			if (!profile) return;

			const isEmiratesId = isEmiratesIdDocumentType(
				profile?.documentClassCode ?? profile?.documentType,
				documentTypeLabelRef?.current ?? profile?.documentType
			);

			if (isEmiratesId) {
				const uaeCountry = getUaeCountry();

				if (uaeCountry) {
					handlers['countryOfResidence']?.(uaeCountry.CountryCode);
					setResidenceCountryLabel(uaeCountry.CountryName);

					handlers['issueCountry']?.(uaeCountry.CountryCode);
					setIssueCountryLabel(uaeCountry.CountryName);
				}
			}
			dispatch(setGuestVerificationLazyLoad(false));
		}, [profile, countries]);

		const handleSelectChange = (elementName: string, selectedOption: any) => {
			if (elementName === 'documentType') {
				const currentDocType = refs['documentType']?.current;
				if (currentDocType && currentDocType !== selectedOption?.value) {
					Swal.fire({
						title: t('Confirmation') || 'Confirmation',
						text:
							t('Are you sure you want to change the document type?') ||
							'Are you sure you want to change the document type?',
						icon: 'warning',
						showCancelButton: true,
						confirmButtonText: t('Yes') || 'Yes',
						cancelButtonText: t('No') || 'No',
					}).then((result) => {
						if (result.isConfirmed) {
							processSelectChange(elementName, selectedOption);
						}
					});
					return;
				}
			}

			processSelectChange(elementName, selectedOption);
		};

		const processSelectChange = (elementName: string, selectedOption: any) => {
			const selectedValue = selectedOption?.value ?? '';
			handlers[elementName](selectedValue);
			if (elementName === 'countryOfResidence') {
				refs[elementName].current = selectedValue;
				vars[elementName] = selectedValue;
			}

			// setValidationErrorEU(false);
			const hasInvalidInputs = false;
			/* eslint-disable no-debugger */
			debugger;
			if (elementName === 'nationality') {
				setNationalityCountryLabel(selectedOption?.label);
			}
			if (elementName === 'nationalityCode') {
				setNationalityCountryLabel(selectedOption?.label);
			} else if (elementName === 'countryOfResidence') {
				// setResidenceCountryLabel(selectedOption?.label);
				// const selectedCountry = countries.find(
				// 	(country: CountryItem) =>
				// 		country.CountryCode === selectedOption?.value
				// );
				// const defaultPhoneCode = formatPhoneCode(
				// 	selectedCountry?.PhoneCode ?? ''
				// );
				// setSelectedPhoneCodeByField((prevState: Record<string, string>) => {
				// 	const nextState = { ...prevState };
				// 	fields.forEach((field: any) => {
				// 		if (
				// 			isPhoneOrMobileField(field.fieldCode ?? '', field.fieldName ?? '')
				// 		) {
				// 			nextState[field.fieldCode] = defaultPhoneCode;
				// 		}
				// 	});
				// 	return nextState;
				// });

				setResidenceCountryLabel(selectedOption?.label);
				applyResidencePhoneCodeToPhoneFields(selectedOption?.value);
				// Also clear phone when country changes
				fields.forEach((field: any) => {
					const fieldCode = field.fieldCode?.toString() ?? '';
					const fieldName = field.fieldName?.toString() ?? '';
					if (
						isPhoneOrMobileField(fieldCode, fieldName) &&
						!isUAEPhoneField(fieldCode, fieldName) &&
						handlers[fieldCode]
					) {
						handlers[fieldCode]('');
					}
				});
			} else if (elementName === 'issueCountry') {
				setIssueCountryLabel(selectedOption?.label);
			} else if (elementName === 'purposeOfVisit') {
				setPurposeOfVisitLabel(selectedOption?.label);
				if (!isOtherOption(selectedOption)) {
					setPurposeOfVisitOtherText('');
				}
			} else if (elementName === 'accessibilityPreference') {
				setAccessibilityPreferenceLabel(selectedOption?.label);
				if (!isOtherOption(selectedOption)) {
					setAccessibilityPreferenceOtherText('');
				}
			} else if (elementName === 'gender') {
				setGenderLabel(selectedOption?.label);
			} else if (elementName === 'documentType') {
				setDocumentTypeLabel(selectedOption?.label);
				if (
					isEmiratesIdDocumentType(
						selectedOption?.value?.toString(),
						selectedOption?.label?.toString()
					)
				) {
					const uaeCountry = getUaeCountry();
					if (uaeCountry) {
						handlers['countryOfResidence']?.(uaeCountry.CountryCode);
						setResidenceCountryLabel(uaeCountry.CountryName);
					}
				}
			}
			setFieldErrors((prev) => {
				const next = { ...prev };
				delete next[elementName];
				return next;
			});

			// const countryOfResidence = countries.find(
			// 	(country: any) => country.CountryID === selectedOption?.value
			// );

			// if (selectedOption?.label && elementName === 'countryOfResidence') {
			// 	if (countryOfResidence) {
			// 		handlers['phoneCode'](countryOfResidence?.PhoneCode);
			// 		setPhoneCodeLabel(`${countryOfResidence?.PhoneCode}`);
			// 	}
			// }
			//setinvalidInputs(hasInvalidInputs);
			invalidInputs = hasInvalidInputs;
		};

		const isPhoneOrMobileField = (fieldCode: string, fieldName: string) => {
			const code = (fieldCode || '').toLowerCase();
			const name = (fieldName || '').toLowerCase();
			return (
				((code.includes('phone') || code.includes('mobile')) &&
					!code.includes('email')) ||
				((name.includes('phone') || name.includes('mobile')) &&
					!name.includes('email'))
			);
		};

		const isUAEPhoneField = (fieldCode: string, fieldName: string) => {
			const code = (fieldCode || '').toLowerCase();
			const name = (fieldName || '').toLowerCase();
			return code === 'phoneno_uae' || name === 'phoneno_uae';
		};

		const formatPhoneCode = (phoneCode: string) => {
			const trimmed = (phoneCode || '').trim();
			if (!trimmed) return '';
			return trimmed.startsWith('+') ? trimmed : `+${trimmed}`;
		};

		const applyResidencePhoneCodeToPhoneFields = (countryCode: string) => {
			/* eslint-disable no-debugger */
			debugger;
			const selectedCountry = countries.find(
				(country: CountryItem) => country.countryCode === countryCode
			);
			const defaultPhoneCode = formatPhoneCode(
				selectedCountry?.phoneCode ?? ''
			);

			setSelectedPhoneCodeByField((prevState: Record<string, string>) => {
				const nextState = { ...prevState };

				nextState['phoneNo_Res'] = defaultPhoneCode;
				fields.forEach((field: any) => {
					const fieldCode = field.fieldCode?.toString() ?? '';
					const fieldName = field.fieldName?.toString() ?? '';
					if (
						isPhoneOrMobileField(fieldCode, fieldName) &&
						!isUAEPhoneField(fieldCode, fieldName)
					) {
						nextState[fieldCode] = defaultPhoneCode;
					}
				});
				return nextState;
			});
		};

		const arabicNumericPattern = /[0-9\u0660-\u0669\u06F0-\u06F9]/;
		const arabicAllowedCharactersPattern =
			/^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\s]+$/;
		const sanitizeArabicOnlyText = (value: string) =>
			value
				.replace(/[0-9\u0660-\u0669\u06F0-\u06F9]/g, '')
				.replace(/[^\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\s]/g, '');
		const isArabicOnlyText = (value: string) =>
			arabicAllowedCharactersPattern.test(value) &&
			!arabicNumericPattern.test(value);

		const getCountryData = () => countries ?? [];

		const getUAECountryItem = () => {
			const data = getCountryData();
			if (!data.length) return undefined;
			const preferredARE = data.find((country: CountryItem) => {
				const countryCode = (country?.countryCode || '').toUpperCase();
				return countryCode === 'ARE';
			});

			if (preferredARE) return preferredARE;
			return data.find((country: CountryItem) => {
				const countryCode = (country?.countryCode || '').toUpperCase();
				const countryName = (country?.countryName || '').toUpperCase();
				return (
					countryCode === 'ARE' ||
					countryCode === 'UAE' ||
					countryName.includes('UNITED ARAB EMIRATES')
				);
			});
		};

		const getUAEPhoneCode = () => {
			const uaeCountry = getUAECountryItem();
			return formatPhoneCode(uaeCountry?.phoneCode ?? '');
		};

		const getSelectedCountryPhoneCode = () => {
			const data = getCountryData();
			const selectedCountryId =
				refs['countryOfResidence']?.current ?? vars['countryOfResidence'];
			let selectedCountry = data.find(
				(country: CountryItem) => country.countryCode === selectedCountryId
			);

			// Fallback for initial profile data when country ID isn't set in refs yet.
			if (!selectedCountry) {
				selectedCountry = data.find(
					(country: CountryItem) =>
						country.countryCode === profile?.issuingStateCode ||
						country.countryCode === profile?.countryOfResidence
				);
			}

			return formatPhoneCode(selectedCountry?.phoneCode ?? '');
		};

		const getSelectedPhoneCodeForField = (
			fieldCode: string,
			fieldName = ''
		) => {
			const normalizedFieldCode = (fieldCode || '').toLowerCase();
			if (isUAEPhoneField(fieldCode, fieldName)) {
				return (
					selectedPhoneCodeByFieldRef?.current?.[fieldCode] || getUAEPhoneCode()
				);
			}
			if (normalizedFieldCode === 'phoneno_res') {
				return (
					selectedPhoneCodeByFieldRef?.current?.[fieldCode] ||
					getSelectedCountryPhoneCode() ||
					''
				);
			}
			return (
				selectedPhoneCodeByFieldRef?.current?.[fieldCode] ||
				getSelectedCountryPhoneCode()
			);
		};

		const updateSelectedPhoneCodeForField = (
			fieldCode: string,
			phoneCode: string
		) => {
			const formattedCode = formatPhoneCode(phoneCode);
			setSelectedPhoneCodeByField((prevState: Record<string, string>) => ({
				...prevState,
				[fieldCode]: formattedCode,
			}));
		};

		const getPhoneValueWithSelectedCode = (
			rawValue: any,
			fieldCode: string
		) => {
			const raw = `${rawValue ?? ''}`.trim();
			if (!raw) return '';

			const code = getSelectedPhoneCodeForField(fieldCode);
			const formattedCode = formatPhoneCode(code || '');
			if (!formattedCode) return raw;

			const digitsOnly = raw.replace(/[^\d]/g, '');
			const codeDigitsOnly = formattedCode.replace(/[^\d]/g, '');

			if (digitsOnly.startsWith(codeDigitsOnly)) {
				return `+${digitsOnly}`;
			}

			return `${formattedCode}${digitsOnly}`;
		};

		const getDigitsOnly = (value?: string) =>
			`${value ?? ''}`.replace(/\D/g, '');

		const toNumber = (value: any): number | undefined => {
			if (value === null || value === undefined || value === '') {
				return undefined;
			}
			const parsed = Number(value);
			return Number.isFinite(parsed) ? parsed : undefined;
		};

		const normalizeCountryCode = (value: any) =>
			value ? value.toString().toUpperCase() : '';

		const getCountryOfResidenceCode = () =>
			refs['countryOfResidence']?.current ??
			vars['countryOfResidence'] ??
			profile?.countryOfResidence ??
			profile?.issuingStateCode ??
			'';

		const getCountryForPhoneField = (fieldCode: string) => {
			const data = getCountryData();

			if (!data.length) return undefined;

			if (isUAEPhoneField(fieldCode, '')) {
				return getUAECountryItem();
			}

			const code = normalizeCountryCode(getCountryOfResidenceCode());
			if (!code) return undefined;
			return data.find(
				(country: CountryItem) =>
					normalizeCountryCode(country.countryCode) === code
			);
		};

		const getPhoneLengthLimitsForField = (fieldCode: string) => {
			const country = getCountryForPhoneField(fieldCode);
			return {
				min: toNumber(country?.PhoneNumberMinLength),
				max: toNumber(country?.PhoneNumberMaxLength),
			};
		};

		const getPhoneLengthError = (fieldCode: string, value: string) => {
			const digits = getDigitsOnly(value);
			if (!digits) return undefined;
			const { min, max } = getPhoneLengthLimitsForField(fieldCode);
			if (typeof min === 'number' && min > 0 && digits.length < min) {
				return `Phone number must be at least ${min} digits.`;
			}
			if (typeof max === 'number' && max > 0 && digits.length > max) {
				return `Phone number cannot exceed ${max} digits.`;
			}
			return undefined;
		};

		const applyMaxPhoneLength = (fieldCode: string, value: string) => {
			const { max } = getPhoneLengthLimitsForField(fieldCode);
			if (typeof max === 'number' && max > 0) {
				return value.slice(0, max);
			}
			return value;
		};

		const getPlaceOfIssueOption = (value: any) => {
			const normalizedValue = (value ?? '').toString().trim().toLowerCase();
			if (!normalizedValue) return null;

			return (
				placeOfIssueOptions.find(
					(option) =>
						option.value.toLowerCase() === normalizedValue ||
						option.label.toLowerCase() === normalizedValue
				) ?? null
			);
		};

		const shouldFormatOnBlur = (fieldCode: string, fieldName: string) =>
			fieldCode !== 'email' &&
			fieldCode !== 'carPlateNumber' &&
			fieldCode !== 'documentNumber' &&
			!isPhoneOrMobileField(fieldCode, fieldName);

		const getSelectOptions = (
			element: string,
			isArrivalTimeDropdown: boolean
		) => {
			if (element === 'nationality') {
				return nationalityCountryRef?.current ?? [];
			}
			if (element === 'countryOfResidence') {
				return residenceCountryRef?.current ?? [];
			}
			if (element === 'issueCountry') {
				return issueCountryRef?.current ?? [];
			}
			if (element === 'placeOfIssue') {
				return placeOfIssueOptions;
			}
			if (element === 'purposeOfVisit') {
				return purposeOfVisitRef?.current ?? [];
			}
			if (element === 'accessibilityPreference') {
				return accessibilityPrefsRef?.current ?? [];
			}
			if (element === 'gender') {
				return genderOptions;
			}
			if (element === 'documentType' && supportDocs) {
				return supportDocs.map((doc: any) => ({
					value: doc.bODocumentType,
					label: doc.documentName,
				}));
			}
			if (isArrivalTimeDropdown) {
				return arrivalTimeOptions;
			}
			return [];
		};

		// checkEmailAndPhone();
		//checkMandatory();
		const fieldsByCategory: Record<string, typeof fields> = {};

		fields.forEach((field: any) => {
			const category = field.fieldCategory || 'General';
			if (!fieldsByCategory[category]) {
				fieldsByCategory[category] = [];
			}
			fieldsByCategory[category].push(field);
		});

		return lazyLoadRef?.current === false ? (
			<div
				style={{
					marginBottom: '100px',
				}}>
				<form className="row pt-2 px-3 mx-auto" style={{ maxWidth: '1200px' }}>
					{/* <div className="col-12 d-flex justify-content-end mb-2">
						<button
							type="button"
							className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-2"
							onClick={() => {
								if (
									token &&
									reservation?.PmsConfirmationNo &&
									profile?.profileID
								) {
									dispatch(
										fetchSingleProfile({
											token,
											confirmationNo: reservation.PmsConfirmationNo,
											profileId: profile.profileID,
										})
									);
								} else {
									window.location.reload();
								}
							}}
							style={{
								borderRadius: '20px',
								padding: '6px 16px',
								fontSize: '0.85rem',
								fontWeight: 500,
								border: '1px solid #dee2e6',
								backgroundColor: '#fff',
								color: '#6c757d',
								boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
							}}>
							<FontAwesomeIcon icon={faRedo} style={{ fontSize: '0.8rem' }} />
							{t('ReloadForm')}
						</button>
					</div> */}
					{Object.keys(fieldsByCategory).map((category) => (
						<div key={category} className="col-12 mb-4">
							{/* Category Heading */}
							<h5
								className="mb-3"
								style={{
									borderBottom: '1px solid #ccc',
									paddingBottom: '0.5rem',
									fontWeight: 'bold',
									paddingTop: '1.5rem',
								}}>
								{category}
							</h5>

							{/* Render fields for this category */}
							{fieldsByCategory[category].map((field: any) => {
								const {
									fieldName,
									fieldDesc,
									fieldCode,
									fieldType,
									validationType,
									validationMessage,
									isUDF,
									modelFieldCode,
									boDocumentType,
									operaDocumentCode,
								} = field;

								if (!fieldCode) return null;

								const currentDocType =
									refs['documentType']?.current ??
									vars['documentType'] ??
									profile?.documentClassCode ??
									profile?.documentType ??
									null;

								let shouldShowField = true;
								if (
									boDocumentType &&
									boDocumentType !== null &&
									boDocumentType !== ''
								) {
									if (!currentDocType) {
										shouldShowField = false;
									} else {
										const fieldDocTypes = boDocumentType
											.toString()
											.split(',')
											.map((s: string) => s.trim().toLowerCase())
											.filter(Boolean);
										const selectedDocTypes = currentDocType
											.toString()
											.split(',')
											.map((s: string) => s.trim().toLowerCase())
											.filter(Boolean);
										shouldShowField = fieldDocTypes.some((type: string) =>
											selectedDocTypes.includes(type)
										);
									}
								}

								if (!shouldShowField) {
									return null;
								}

								const element = fieldCode.toString();
								const isArrivalTimeDropdown =
									element.toLowerCase() === 'arrivaltime';
								const elementName = fieldName.toString();
								const inputValue = refs[element]?.current || '';
								const isFieldMandatory = field.isMandatory || false;
								const Message = field.validationMessage || '';
								const IsUDFField = field.isUDF || false;
								const initialFieldValue = getInitialState(
									element,
									profile,
									profileDtl,
									fieldAlias
								);
								const isInitialFieldEmpty =
									initialFieldValue === null ||
									initialFieldValue === undefined ||
									initialFieldValue.toString().trim() === '' ||
									initialFieldValue === 0 ||
									initialFieldValue === '0';
								const isDateOrTimeField =
									fieldType?.toLowerCase() === 'date' ||
									fieldType?.toLowerCase() === 'time';

								// For USER model fields: if the current value is empty (eg. an empty Select),
								// allow the user to edit even when `disableUserFields` is true.
								const isUserModelField = modelFieldCode === 'USER';
								const currentFieldValue =
									refs[element]?.current ?? initialFieldValue ?? '';
								let isFieldEmptyCurrently = false;
								if (
									currentFieldValue === null ||
									currentFieldValue === undefined
								) {
									isFieldEmptyCurrently = true;
								} else if (typeof currentFieldValue === 'string') {
									isFieldEmptyCurrently =
										currentFieldValue.toString().trim() === '';
								} else if (typeof currentFieldValue === 'object') {
									// For Selects the stored value might be an object; consider empty when it has no meaningful value
									if ('value' in (currentFieldValue as any)) {
										const v = (currentFieldValue as any).value;
										isFieldEmptyCurrently =
											v === null ||
											v === undefined ||
											(typeof v === 'string' && v.trim() === '');
									} else {
										isFieldEmptyCurrently =
											Object.keys(currentFieldValue).length === 0;
									}
								} else {
									isFieldEmptyCurrently =
										currentFieldValue === 0 || currentFieldValue === '0';
								}

								const shouldDisableUserField =
									disableUserFields &&
									isUserModelField &&
									// if the field is currently empty, allow editing regardless of disable flag
									!isFieldEmptyCurrently &&
									!(isFieldMandatory && isInitialFieldEmpty) &&
									!isDateOrTimeField;
								vars[element] = inputValue;

								// Handle Input fields
								if (fieldType === 'Input') {
									const showCountryPhoneCode = isPhoneOrMobileField(
										element,
										elementName
									);
									const selectedCountryPhoneCode = showCountryPhoneCode
										? getSelectedPhoneCodeForField(element, elementName)
										: '';
									return (
										<div
											className="form-group col-lg-4 col-md-6 mb-3"
											key={element}>
											<label htmlFor={element}>
												{elementName}{' '}
												{(isFieldMandatory || validationErrorEU) && (
													<span style={{ color: 'red' }}>*</span>
												)}
											</label>
											<div
												className={
													showCountryPhoneCode ? 'input-group' : undefined
												}>
												{showCountryPhoneCode && (
													<div style={{ minWidth: '120px' }}>
														<Select
															options={phoneCodeRef?.current ?? []}
															isSearchable
															isDisabled={
																isUAEPhoneField(element, elementName) ||
																shouldDisableUserField
															}
															placeholder="Choose"
															isRtl={false}
															value={
																(phoneCodeRef?.current ?? []).find(
																	(option: PhoneCodeSelect) =>
																		option.value === selectedCountryPhoneCode
																) ?? null
															}
															onChange={(selectedOption: any) =>
																updateSelectedPhoneCodeForField(
																	element,
																	selectedOption?.value ?? ''
																)
															}
															styles={searchableSelectStyles}
														/>
													</div>
												)}
												<input
													type="text"
													className={`form-control ${
														fieldErrors[element] ? 'is-invalid' : ''
													}`}
													id={element}
													dir={
														element === 'arabicName' ||
														element === 'arabicLastName' ||
														element === 'arabicFullName'
															? 'ltr'
															: undefined
													}
													disabled={shouldDisableUserField}
													placeholder={placeholderMap[element]}
													value={inputValue}
													style={
														element === 'arabicName' ||
														element === 'arabicLastName' ||
														element === 'arabicFullName'
															? {
																	textAlign:
																		element === 'arabicName' ||
																		element === 'arabicLastName' ||
																		element === 'arabicFullName'
																			? 'right'
																			: 'left',
															  }
															: undefined
													}
													onChange={(e) => {
														let value = e.target.value;
														if (
															element === 'arabicName' ||
															element === 'arabicLastName' ||
															element === 'arabicFullName'
														) {
															value = sanitizeArabicOnlyText(value);
														} else {
															value = value.trimStart();
															if (showCountryPhoneCode) {
																value = value.replace(/\D/g, '');
																value = applyMaxPhoneLength(element, value);
															}
														}
														const error = validateInput(
															value,
															element,
															elementName,
															isFieldMandatory,
															validationType,
															Message,
															fieldType,
															IsUDFField,
															boDocumentType
														);
														handlers[element](value);
														setValidationError(error || '');
														setErrorField(error ? element : '');
													}}
													onBlur={() => {
														if (
															element === 'arabicName' ||
															element === 'arabicLastName' ||
															element === 'arabicFullName' ||
															!shouldFormatOnBlur(element, elementName)
														) {
															return;
														}
														const currentValue = refs[element]?.current ?? '';
														const formattedValue =
															getCapitalCase(currentValue) ?? '';
														if (formattedValue !== currentValue) {
															handlers[element](formattedValue);
														}
													}}
												/>
											</div>
											{isUAEPhoneField(element, elementName) ? (
												<small className="text-muted d-block mt-1">
													<span className="helper-info-icon" aria-hidden="true">
														i
													</span>
													If you dont have a UAE phone number, please provide
													the hotel number where you are staying.
												</small>
											) : isPhoneOrMobileField(element, elementName) ? (
												<small className="text-muted d-block mt-1">
													<span className="helper-info-icon" aria-hidden="true">
														i
													</span>
													If you live in the UAE, you can enter your UAE number
													for both fields.
												</small>
											) : null}
											{fieldErrors[element] && (
												<div
													className="invalid-feedback"
													style={{ display: 'block' }}>
													{fieldErrors[element]}
												</div>
											)}
										</div>
									);
								}

								// Handle Date fields
								if (fieldType === 'date' || fieldType === 'Date') {
									return (
										<div
											className="form-group col-lg-4 col-md-6 mb-3"
											key={element}>
											<label htmlFor={element}>
												{elementName}{' '}
												{(isFieldMandatory || validationErrorEU) && (
													<span style={{ color: 'red' }}>*</span>
												)}
											</label>
											<DatePicker
												id={element}
												selected={getDateFormatted(vars[element])}
												wrapperClassName={`${styles.datePicker}`}
												maxDate={(() => {
													const isDOB = element
														.toLowerCase()
														.includes('dateofbirth');
													if (isDOB && profile?.isChild && childMinAgeDate) {
														return childMinAgeDate;
													}
													if (isDOB && !profile?.isChild && adultMinAgeDate) {
														return adultMinAgeDate;
													}
													if (
														field.validationType === 'pastdate' ||
														field.validationType === 'todayorpast'
													) {
														return new Date();
													}
													return undefined;
												})()}
												minDate={
													field.validationType === 'futuredate' ||
													field.validationType === 'todayorfuture'
														? new Date()
														: undefined
												}
												onChange={(date) =>
													handleDatePickerChange(
														date,
														element,
														elementName,
														isFieldMandatory,
														validationType,
														Message,
														fieldType,
														boDocumentType
													)
												}
												// minDate={
												// 	element.toLowerCase() === 'expirydate'
												// 		? new Date()
												// 		: undefined
												// }
												// maxDate={
												// 	element.toLowerCase() === 'issuedate' ||
												// 	element.toLowerCase() === 'dateofbirthdt' ||
												// 	element.toLowerCase() === 'dateofbirth'
												// 		? new Date()
												// 		: undefined
												// }
												className={`form-control px-3 py-2 shadow-sm ${
													styles.reactwrapper
												} ${fieldErrors[element] ? 'is-invalid' : ''}`}
												placeholderText="Select date"
												dateFormat="dd-MM-yyyy"
												showMonthDropdown
												showYearDropdown
												scrollableYearDropdown
												yearDropdownItemNumber={100}
												disabled={shouldDisableUserField}
											/>
											{fieldErrors[element] && (
												<div
													className="invalid-feedback"
													style={{ display: 'block' }}>
													{fieldErrors[element]}
												</div>
											)}
										</div>
									);
								}

								if (
									(fieldType === 'time' || fieldType === 'Time') &&
									!isArrivalTimeDropdown
								) {
									return (
										<div
											className="form-group col-lg-4 col-md-6 mb-3"
											key={element}>
											<label htmlFor={element}>
												{elementName}{' '}
												{(isFieldMandatory || validationErrorEU) && (
													<span style={{ color: 'red' }}>*</span>
												)}
											</label>
											<DatePicker
												id={element}
												wrapperClassName={`${styles.datePicker}`}
												selected={getTimeFormatted(vars[element])}
												onChange={(date) =>
													handleDatePickerChange(
														date,
														element,
														elementName,
														isFieldMandatory,
														validationType,
														Message,
														fieldType,
														boDocumentType
													)
												}
												showTimeSelect
												showTimeSelectOnly
												timeIntervals={15} // adjust intervals as needed
												timeCaption="Time"
												dateFormat="HH:mm" // 24-hour format, use 'hh:mm aa' for 12-hour
												className={`form-control px-3 py-2 shadow-sm col-lg-12 col-md-12 ${
													fieldErrors[element] ? 'is-invalid' : ''
												}`}
												placeholderText="Select time"
												disabled={shouldDisableUserField}
											/>
											{fieldErrors[element] && (
												<div
													className="invalid-feedback"
													style={{ display: 'block' }}>
													{fieldErrors[element]}
												</div>
											)}
										</div>
									);
								}
								// Handle Dropdown
								if (fieldType === 'Dropdown' || isArrivalTimeDropdown) {
									const showPurposeOther =
										element === 'purposeOfVisit' &&
										isOtherLabel(purposeOfVisitLabelRef?.current);
									const showAccessibilityOther =
										element === 'accessibilityPreference' &&
										isOtherLabel(accessibilityPreferenceLabelRef?.current);

									return (
										<React.Fragment key={element}>
											<div className="form-group col-lg-4 col-md-6 mb-3">
												<label htmlFor={element}>
													{elementName}{' '}
													{(isFieldMandatory || validationErrorEU) && (
														<span style={{ color: 'red' }}>*</span>
													)}
												</label>
												<Select
													id={element}
													options={getSelectOptions(
														element,
														isArrivalTimeDropdown
													)}
													// value={getSelectValue(element, isArrivalTimeDropdown)}
													value={
														isArrivalTimeDropdown
															? arrivalTimeOptions.find(
																	(opt) => opt.value === refs[element]?.current
															  ) || null
															: element === 'placeOfIssue'
															? getPlaceOfIssueOption(refs[element]?.current)
															: refs[element]?.current
															? {
																	value: refs[element]?.current,
																	label:
																		element === 'nationality'
																			? nationalityCountryLabelRef?.current
																			: element === 'countryOfResidence'
																			? residenceCountryLabelRef?.current
																			: element === 'issueCountry'
																			? issueCountryLabelRef?.current
																			: element === 'purposeOfVisit'
																			? purposeOfVisitLabelRef?.current
																			: element === 'accessibilityPreference'
																			? accessibilityPreferenceLabelRef?.current
																			: element === 'gender'
																			? genderLabelRef?.current
																			: element === 'documentType' &&
																			  supportDocs
																			? documentTypeLabelRef?.current ||
																			  supportDocs.find(
																					(doc: any) =>
																						doc.operaDocumentCode ===
																							refs[element]?.current ||
																						(doc?.bODocumentType ?? '')
																							.toString()
																							.split(',')
																							.map((value: string) =>
																								value.trim()
																							)
																							.filter(Boolean)
																							.includes(refs[element]?.current)
																			  )?.documentName ||
																			  ''
																			: isArrivalTimeDropdown
																			? refs[element]?.current
																			: '',
															  }
															: null
													}
													onChange={(selectedOption) =>
														handleSelectChange(element, selectedOption)
													}
													isSearchable={
														!isArrivalTimeDropdown || element === 'documentType'
													}
													isClearable={element !== 'documentType'}
													isDisabled={
														element === 'documentType' ||
														(element === 'countryOfResidence' &&
															isEmiratesIdDocumentType(
																(
																	refs['documentType']?.current ??
																	vars['documentType'] ??
																	profile?.documentClassCode ??
																	profile?.documentType ??
																	''
																).toString(),
																(
																	documentTypeLabelRef?.current ??
																	profile?.documentType ??
																	''
																).toString()
															)) ||
														shouldDisableUserField
													}
													className={`shadow-sm ${
														fieldErrors[element] ? 'is-invalid' : ''
													}`}
													placeholder={
														element === 'purposeOfVisit'
															? 'Select purpose of visit'
															: element === 'accessibilityPreference'
															? 'Select accessibility preference'
															: element === 'documentType'
															? 'Select document type'
															: 'Select'
													}
													isRtl={false}
													styles={searchableSelectStyles}
												/>
												{fieldErrors[element] && (
													<div
														className="invalid-feedback"
														style={{ display: 'block' }}>
														{fieldErrors[element]}
													</div>
												)}
											</div>

											{showPurposeOther && (
												<div className="form-group col-lg-4 col-md-6 mb-3">
													<label htmlFor="purposeOfVisitOther">
														Please specify
													</label>
													<input
														id="purposeOfVisitOther"
														type="text"
														className={`form-control px-3 py-2 shadow-sm ${
															fieldErrors['purposeOfVisitOther']
																? 'is-invalid'
																: ''
														}`}
														value={purposeOfVisitOtherText}
														onChange={(e) => {
															setPurposeOfVisitOtherText(e.target.value);
															setFieldErrors((prev) => {
																const next = { ...prev };
																delete next['purposeOfVisitOther'];
																return next;
															});
														}}
													/>
													{fieldErrors['purposeOfVisitOther'] && (
														<div
															className="invalid-feedback"
															style={{ display: 'block' }}>
															{fieldErrors['purposeOfVisitOther']}
														</div>
													)}
												</div>
											)}

											{showAccessibilityOther && (
												<div className="form-group col-lg-4 col-md-6 mb-3">
													<label htmlFor="accessibilityPreferenceOther">
														Please specify
													</label>
													<input
														id="accessibilityPreferenceOther"
														type="text"
														className={`form-control px-3 py-2 shadow-sm ${
															fieldErrors['accessibilityPreferenceOther']
																? 'is-invalid'
																: ''
														}`}
														value={accessibilityPreferenceOtherText}
														onChange={(e) => {
															setAccessibilityPreferenceOtherText(
																e.target.value
															);
															setFieldErrors((prev) => {
																const next = { ...prev };
																delete next['accessibilityPreferenceOther'];
																return next;
															});
														}}
													/>
													{fieldErrors['accessibilityPreferenceOther'] && (
														<div
															className="invalid-feedback"
															style={{ display: 'block' }}>
															{fieldErrors['accessibilityPreferenceOther']}
														</div>
													)}
												</div>
											)}
										</React.Fragment>
									);
								}

								return null;
							})}
						</div>
					))}
				</form>

				{isRefreshLoader === true && (
					<>
						<Modal
							centered
							backdrop="static"
							keyboard={false}
							show={isRefreshLoader}
							onHide={() => setRefreshLoader(false)}
							contentClassName="skip-modal-content">
							<Modal.Body>
								<p
									className="p-2 text-center m-0 lh-sm"
									style={{ fontSize: '1rem' }}>
									{t('Please Wait')}
								</p>
								<div
									className="spinner-grow my-auto text-center"
									style={{ margin: 'auto', display: 'flex' }}
									role="status"
								/>
							</Modal.Body>
						</Modal>
					</>
				)}
			</div>
		) : null;
	}
);

GuestProfileFormContent.displayName = 'GuestProfileFormContent';

export const GuestProfileForm = forwardRef<any, Props>((props, ref) => {
	const dispatch = useAppDispatch();
	const {
		token,
		visitPurposes,
		accessibilityPreferences,
		settings,
		supportDocs,
	} = useAppSelector(selectSession);
	const { countries, fields } = props;
	const { currentProfile } = useAppSelector(selectProfile);

	const { reservation } = useAppSelector(selectSession);

	// Master data check: Wait for all dependencies
	const isDataMissing =
		!countries ||
		!fields ||
		!supportDocs ||
		!visitPurposes ||
		!accessibilityPreferences ||
		!settings;

	useEffect(() => {
		if (isDataMissing) {
			dispatch(setGuestVerificationLazyLoad(true));
		}
		// else {
		// 	dispatch(setGuestVerificationLazyLoad(false));
		// }
	}, [isDataMissing, dispatch]);

	const [isProfileLoading, setIsProfileLoading] = useState(true);
	useEffect(() => {
		setIsProfileLoading(true);
		dispatch(
			fetchSingleProfile({
				token,
				confirmationNo: reservation.PmsConfirmationNo,
				profileId: currentProfile.profileID,
			})
		)
			.unwrap()
			.then(() => {
				setIsProfileLoading(false);
			})
			.catch(() => setIsProfileLoading(false));
	}, [dispatch]);
	useEffect(() => {
		if (token && isDataMissing) {
			dispatch(fetchMasterBootstrap(token));
		}
	}, [token, isDataMissing, dispatch]);

	if (isDataMissing || isProfileLoading) {
		return null;
	}

	return (
		<GuestProfileFormContent {...props} profileDtl={currentProfile} ref={ref} />
	);
});

GuestProfileForm.displayName = 'GuestProfileForm';
export default GuestProfileForm;
